import script from "./AnamnesiPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnamnesiPage.vue?vue&type=script&setup=true&lang=ts"

import "./AnamnesiPage.vue?vue&type=style&index=0&id=03052e9d&lang=css"

const __exports__ = script;

export default __exports__